
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns27cf05cbfc26566f6a1d19a0089f7782en from './en.yaml'
            i18n.addResourceBundle('en', '27cf05cbfc26566f6a1d19a0089f7782', flattenObject(ns27cf05cbfc26566f6a1d19a0089f7782en), true, true);
        
        export default '27cf05cbfc26566f6a1d19a0089f7782';
    